export default {
  fr: {
    translation: {
      common: {
        cancel: "Annuler",
        save: "Sauvegarder",
      },
      checkinApp: {
        addSeatNote: "fr..Add Seat Note..fr",
        addCustomerNote: "fr..Add Customer Note..fr",
        addSeatFeedback: "fr..Add Seat Feedback..fr",
        addLoungePreferences: "fr..In Lounge Preferences..fr",
        noteEditor: {
          heading: "fr..Edit Note..fr",
          placeholder: "fr..type note here.....fr",
        },
        loungePreferencesEditor: {
          heading: "fr..Edit Lounge Preferences..fr",
          placeholder: "fr..type lounge preferences here.....fr",
        },
        seatFeedback: {
          editor: {
            heading: "fr..Edit Seat Feedback..fr",
            note_html:
              'fr..<b>Note:</b> For this flight only. Use "Customer Notes" to appear on future flights...fr',
            placeholder:
              "fr..Why this airport, time, flight, one-way, round-trip?     Did this chedule flight time work for you?     Did you know about Ground Connect?     First time flyer?     How did you hear about us?     How was your booking experience?..fr",
          },
          text: {
            heading: "fr..Seat Feedback:..fr",
            edit: "fr..Edit..fr",
          },
        },
      },
      salespersonTypeahead: {
        label: "Venduer",
        placeholder: "Ajouter un vendeur",
      },
      addDiscountModal: {
        title: "Ajouter une remise",
        price: {
          label: "Prix :",
        },
        qty: {
          label: "Qté :",
        },
        discount: {
          label: "Remise :",
        },
        taxes: {
          label: "Taxes :",
        },
        total: {
          label: "Total :",
        },
        discountAmountPreTax: {
          label: "Montant de la remise (HT)",
          errors: {
            required: "La remise est obligatoire",
            negative: "La remise ne peut pas être négative",
            moreThanItemTotal: "La remise ne peut pas être supérieure au total",
            moreThanGrossAmount:
              "La remise ne peut être supérieure au montant brut (prix catalogue x quantité).",
          },
        },
        totalIncludingDiscount: {
          label: "Total comprenant la remise :",
        },
        reason: {
          label: "Raison",
          select: "Sélectionner une raison de remise",
          errors: {
            required: "La raison est obligatoire.",
          },
        },
        discountDescription: {
          label: "Description de la remise",
          info: "Visible pour les clients sur la facture et l'email de confirmation.",
          errors: {
            required: "La description est obligatoire.",
          },
        },
        notes: {
          label: "Note",
          info: "Notes internes pour l'historique des commandes.",
          errors: {
            required: "La note est obligatoire.",
            minimumNotesCharacters:
              "Les notes doivent comporter un minimum de 10 caractères.",
          },
        },
        reasonWarning: {
          line1:
            "Êtes-vous sûr qu'il s'agit d'une remise exceptionnelle et non d'un autre type de remise ou d'une mémo d'avoir ?",
          line2:
            "Par exemple, si vous soldez une commande d'affrètement, utilisez une note d'avoir au lieu d'une remise.",
        },
      },
      productSearch: {
        enterOrigin: "Saisissez un lieu de départ",
        enterDestination: "Saisissez une destination",
        searchFlights: "Rechercher un vol",
        passengers: "Passagers",
        getNotified: "Être notifié lorsque des nouveaux vols sont disponibles sur ce trajet",
        next: "Suivant",
        searchAll: "Chercher parmi",
        origin: "Lieu de départ",
        destination: "Destination"
      },
      originSearch: {
        suggestedCharter: "Réserver un charter ou un vol Crowdsource (participatif) depuis ",
        suggested: "Suggestions",
        label: "D’où partez vous?",
        placeholder: "Chercher parmi tout les points de départ",
        origins: "tout les points de départ"
      },
      destinationSearch: {
        suggestedCharter: "Réserver un charter ou un vol Crowdsource (participatif) depuis ",
        suggested: "Suggestions",
        label: "Quelle est votre destination?",
        placeholder: "Chercher parmi toutes les destinations",
        destinations: "toutes les destinations"
      },
      stationSearchResults: {
        loading: "Chargement...",
        error: "Désolé, une erreur est survenue. Veuillez réessayer plus tard.",
        no_matches: "Aucun résultat trouvé.",
        all: "Tout les lieux"
      },
      flightSearch: {
        selectReturnDate: "Choisissez une date de retour",
      }
    },
  },
};
